var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            title: _vm.popTitle,
            width: "1280px",
            top: "5vh",
            "custom-class": "dialog_box",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.onClose,
          },
        },
        [
          _vm.componentCode == "topSearch"
            ? _c(
                "div",
                {
                  staticStyle: {
                    "border-bottom": "1px solid #DCDFE6",
                    "margin-bottom": "10px",
                  },
                },
                [
                  _c(
                    "el-form",
                    { attrs: { inline: false, "label-width": "100px" } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "搜索框样式:" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.searchStyle,
                                callback: function ($$v) {
                                  _vm.searchStyle = $$v
                                },
                                expression: "searchStyle",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("胶囊型"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("圆角矩形"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.saveIt },
                            },
                            [_vm._v("保存")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.componentCode == "bottomShopList"
            ? _c(
                "div",
                {
                  staticStyle: {
                    "border-bottom": "1px solid #DCDFE6",
                    "margin-bottom": "10px",
                  },
                },
                [
                  _c(
                    "el-form",
                    { attrs: { inline: false, "label-width": "100px" } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "列表样式:" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.shopListStyle,
                                callback: function ($$v) {
                                  _vm.shopListStyle = $$v
                                },
                                expression: "shopListStyle",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("竖版"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("横版"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.saveShopStyle },
                            },
                            [_vm._v("保存")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "18px",
                        "font-weight": "bold",
                        "margin-bottom": "10px",
                      },
                    },
                    [_vm._v("列表渠道管理")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.componentCode == "bannerWithPuzzle" ||
          _vm.componentCode == "verticalBannerWithPuzzle"
            ? _c(
                "div",
                {
                  staticStyle: {
                    "border-bottom": "1px solid #DCDFE6",
                    "margin-bottom": "10px",
                    "font-size": "20px",
                    "font-weight": "bold",
                    "padding-bottom": "10px",
                  },
                },
                [_vm._v("\n      轮播位管理\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "from_box" },
            [
              _vm.componentCode != "topSearch" &&
              _vm.componentCode != "bottomShopList"
                ? _c(
                    "el-form",
                    {
                      staticClass: "demo-ruleForm",
                      attrs: { inline: true, "label-width": "80px" },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "名称:" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入名称" },
                            model: {
                              value: _vm.title,
                              callback: function ($$v) {
                                _vm.title = $$v
                              },
                              expression: "title",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "是否启用:" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择" },
                              model: {
                                value: _vm.status,
                                callback: function ($$v) {
                                  _vm.status = $$v
                                },
                                expression: "status",
                              },
                            },
                            _vm._l(_vm.options, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.search },
                            },
                            [_vm._v("查询")]
                          ),
                          _vm._v(" "),
                          _c("el-button", { on: { click: _vm.clear } }, [
                            _vm._v("重置"),
                          ]),
                          _vm._v(" "),
                          (_vm.componentCode == "diamond" &&
                            _vm.componentSubcode === "s_a") ||
                          (_vm.componentCode == "diamond" &&
                            _vm.componentSubcode === "s_a_c") ||
                          _vm.componentCode == "banner" ||
                          _vm.componentCode == "bannerWithPuzzle" ||
                          _vm.componentCode == "verticalBannerWithPuzzle" ||
                          _vm.componentCode == "slidingCapsule"
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", plain: "" },
                                  on: { click: _vm.add },
                                },
                                [_vm._v("新增")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                [
                  _vm.componentCode === "bottomShopList"
                    ? _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            "header-cell-style": { "text-align": "center" },
                            "cell-style": { "text-align": "center" },
                            data: _vm.tableData,
                            border: "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: { label: "排序", width: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(scope.$index + 1)),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2966791042
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "名称", width: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(scope.row.categoryName)),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1539246321
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "副标题", width: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(scope.row.subTitle)),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3071498114
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "是否启用", width: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.status === 1
                                              ? "启用"
                                              : "停用"
                                          )
                                        ),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3716528360
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "最后更新时间", width: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(scope.row.updateTime)),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2682808770
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "扩展操作", width: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "mini",
                                            type: "success",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.bannerBuff(scope.row)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                编辑营销位\n              "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1133585139
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "操作", width: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "mini",
                                            type: "primary",
                                            icon: "el-icon-edit",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.changeCategory(
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("编辑")]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1997407714
                            ),
                          }),
                        ],
                        1
                      )
                    : _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            "header-cell-style": { "text-align": "center" },
                            "cell-style": { "text-align": "center" },
                            data: _vm.tableData,
                            border: "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: { label: "排序", width: "" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(scope.$index + 1)),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "图片", width: "" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm.componentCode != "diamond" &&
                                    _vm.componentCode != "topSearch"
                                      ? _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "justify-content": "center",
                                            },
                                          },
                                          [
                                            _vm.componentCode ==
                                            "slidingCapsule"
                                              ? _c("el-image", {
                                                  staticStyle: {
                                                    display: "block",
                                                  },
                                                  attrs: {
                                                    src: scope.row.bannerPic
                                                      ? scope.row.bannerPic
                                                      : require("@/assets/customPage/" +
                                                          _vm.componentCode +
                                                          ".png"),
                                                    fit: "scale-down",
                                                  },
                                                })
                                              : _c("el-image", {
                                                  staticStyle: {
                                                    display: "block",
                                                  },
                                                  attrs: {
                                                    src: scope.row.bannerPic
                                                      ? scope.row.bannerPic
                                                      : require("@/assets/customPage/" +
                                                          (_vm.componentCode !=
                                                            "bannerWithPuzzle" &&
                                                          _vm.componentCode !=
                                                            "verticalBannerWithPuzzle"
                                                            ? _vm.componentSubcode
                                                            : "ba_b") +
                                                          "_" +
                                                          (scope.$index + 1) +
                                                          ".png"),
                                                    fit: "scale-down",
                                                  },
                                                }),
                                          ],
                                          1
                                        )
                                      : _vm.componentCode == "topSearch"
                                      ? _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "justify-content": "center",
                                            },
                                          },
                                          [
                                            _vm.componentSubcode === "ts_5" &&
                                            scope.$index == 0
                                              ? _c("el-image", {
                                                  staticStyle: {
                                                    display: "block",
                                                    height: "40px",
                                                  },
                                                  attrs: {
                                                    src: scope.row.bannerPic
                                                      ? scope.row.bannerPic
                                                      : require("@/assets/customPage/tp_o_icon.png"),
                                                    fit: "scale-down",
                                                  },
                                                })
                                              : _c("el-image", {
                                                  staticStyle: {
                                                    display: "block",
                                                    width: "40px",
                                                    height: "40px",
                                                  },
                                                  attrs: {
                                                    src: scope.row.bannerPic
                                                      ? scope.row.bannerPic
                                                      : require("@/assets/customPage/tp_icon.png"),
                                                    fit: "scale-down",
                                                  },
                                                }),
                                          ],
                                          1
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "justify-content": "center",
                                            },
                                          },
                                          [
                                            _c("el-image", {
                                              staticStyle: {
                                                display: "block",
                                                width: "40px",
                                                height: "40px",
                                              },
                                              attrs: {
                                                src: scope.row.bannerPic
                                                  ? scope.row.bannerPic
                                                  : require("@/assets/customPage/icon.png"),
                                                fit: "scale-down",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "名称", width: "" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(scope.row.bannerName)),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "跳转类型", width: "" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(scope.row.activityTypeName)
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "活动名称", width: "" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(scope.row.activityName)),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "是否启用", width: "" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        style: {
                                          color: !scope.row.status
                                            ? "#999999"
                                            : "#333333",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.status ? "启用" : "停用"
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "创建时间", width: "180" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(scope.row.createTime)),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "有效时间", width: "200" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("div", [
                                      _vm._v(_vm._s(scope.row.startTime)),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", [_vm._v("~")]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v(_vm._s(scope.row.endTime)),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "当前状态" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "justify-content": "center",
                                          "align-items": "center",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            style: {
                                              color:
                                                _vm.realObj[
                                                  scope.row.realStatus
                                                ].color,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.realObj[
                                                  scope.row.realStatus
                                                ].text
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        scope.row.realStatus != 1
                                          ? _c(
                                              "el-tooltip",
                                              {
                                                staticClass: "item",
                                                attrs: {
                                                  effect: "dark",
                                                  content: scope.row.statusDesc,
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c("img", {
                                                  staticStyle: {
                                                    width: "16px",
                                                    height: "16px",
                                                    display: "block",
                                                    margin: "0 0 2px 2px",
                                                  },
                                                  attrs: {
                                                    src: _vm.realObj[
                                                      scope.row.realStatus
                                                    ].src,
                                                  },
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "操作", width: "200" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: "primary",
                                          icon: "el-icon-edit",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.detail(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("编辑")]
                                    ),
                                    _vm._v(" "),
                                    (_vm.componentCode == "diamond" &&
                                      _vm.componentSubcode === "s_a") ||
                                    (_vm.componentCode == "diamond" &&
                                      _vm.componentSubcode === "s_a_c") ||
                                    _vm.componentCode == "banner" ||
                                    _vm.componentCode == "bannerWithPuzzle" ||
                                    _vm.componentCode ==
                                      "verticalBannerWithPuzzle" ||
                                    _vm.componentCode == "slidingCapsule"
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              size: "mini",
                                              type: "danger",
                                              icon: "el-icon-delete",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.del(scope.row)
                                              },
                                            },
                                          },
                                          [_vm._v("删除")]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.componentCode == "bannerWithPuzzle" ||
              _vm.componentCode == "verticalBannerWithPuzzle"
                ? _c(
                    "div",
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "border-bottom": "1px solid #DCDFE6",
                            "margin-bottom": "10px",
                            "font-size": "20px",
                            "font-weight": "bold",
                            "padding-bottom": "10px",
                            "margin-top": "60px",
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.componentCode == "bannerWithPuzzle"
                                  ? "下方拼图"
                                  : "右侧拼图"
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            "header-cell-style": { "text-align": "center" },
                            "cell-style": { "text-align": "center" },
                            data: _vm.puzzleList,
                            border: "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: { label: "排序", width: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(scope.$index + 1)),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2966791042
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "图片", width: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm.componentCode == "bannerWithPuzzle"
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "justify-content": "center",
                                              },
                                            },
                                            [
                                              _c("el-image", {
                                                staticStyle: {
                                                  display: "block",
                                                  width: "40px",
                                                  height: "40px",
                                                },
                                                attrs: {
                                                  src: scope.row.bannerPic
                                                    ? scope.row.bannerPic
                                                    : require("@/assets/customPage/" +
                                                        _vm.componentCode +
                                                        "_" +
                                                        ((scope.$index + 1) %
                                                          2 ===
                                                        0
                                                          ? "left"
                                                          : "right") +
                                                        ".png"),
                                                  fit: "scale-down",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.componentCode ==
                                      "verticalBannerWithPuzzle"
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "justify-content": "center",
                                              },
                                            },
                                            [
                                              _c("el-image", {
                                                staticStyle: {
                                                  display: "block",
                                                  width: "40px",
                                                  height: "40px",
                                                },
                                                attrs: {
                                                  src: scope.row.bannerPic
                                                    ? scope.row.bannerPic
                                                    : require("@/assets/customPage/" +
                                                        _vm.componentSubcode +
                                                        "_" +
                                                        (scope.$index + 1) +
                                                        ".png"),
                                                  fit: "scale-down",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1084792002
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "名称", width: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(scope.row.bannerName)),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2914266773
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "跳转类型", width: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(scope.row.activityTypeName)
                                        ),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2642385652
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "活动名称", width: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(scope.row.activityName)),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1966954316
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "是否启用", width: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "span",
                                        {
                                          style: {
                                            color: !scope.row.status
                                              ? "#999999"
                                              : "#333333",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.status ? "启用" : "停用"
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3903052787
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "创建时间", width: "180" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(scope.row.createTime)),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2774630583
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "有效时间", width: "200" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("div", [
                                        _vm._v(_vm._s(scope.row.startTime)),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", [_vm._v("~")]),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v(_vm._s(scope.row.endTime)),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              318047565
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "当前状态" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "justify-content": "center",
                                            "align-items": "center",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              style: {
                                                color:
                                                  _vm.realObj[
                                                    scope.row.realStatus
                                                  ].color,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.realObj[
                                                    scope.row.realStatus
                                                  ].text
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          scope.row.realStatus != 1
                                            ? _c(
                                                "el-tooltip",
                                                {
                                                  staticClass: "item",
                                                  attrs: {
                                                    effect: "dark",
                                                    content:
                                                      scope.row.statusDesc,
                                                    placement: "top",
                                                  },
                                                },
                                                [
                                                  _c("img", {
                                                    staticStyle: {
                                                      width: "16px",
                                                      height: "16px",
                                                      display: "block",
                                                      margin: "0 0 2px 2px",
                                                    },
                                                    attrs: {
                                                      src: _vm.realObj[
                                                        scope.row.realStatus
                                                      ].src,
                                                    },
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              197169330
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "操作", width: "200" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "mini",
                                            type: "primary",
                                            icon: "el-icon-edit",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.detail(
                                                scope.row,
                                                "noNeed"
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("编辑")]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3019155074
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("addBanner", { ref: "addBanner", on: { refresh: _vm.needRefresh } }),
      _vm._v(" "),
      _c("categoryPop", { ref: "categoryPop", on: { refresh: _vm.findList } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }